import { useQuery } from '@tanstack/react-query'
import { ViewSimpleMovement } from '../../../infra/requests/LogisticsRequests'
import { QUERY_KEYS } from '../../../infra/constants/QueryKeys'

export const useViewSimpleMovement = (id) => {
    const query = useQuery({
        queryKey: [QUERY_KEYS.ViewSimpleMovement, id],
        queryFn: async ({ signal }) => {
            try {
                const currentLanguage = JSON.parse(localStorage.getItem('I18N_LANGUAGE'))
                const response = await ViewSimpleMovement(id, currentLanguage?.id, signal)
                if (!response?.success)
                    throw new Error(response?.message || 'Failed to fetch movement data')
                return response?.data ?? response
            } catch (error) {
                console.error('Movement fetch error:', error)
                throw error
            }
        },
        select: (data) => {
            const itemRows =
                Array.isArray(data) ? data
                    : Array.isArray(data?.itemRows) ? data.itemRows
                        : Array.isArray(data?.data?.itemRows) ? data.data.itemRows
                            : []
            return {
                date: data?.date ?? null,
                movementStatus: data?.movementStatus ?? null,
                itemRows,
            }
        },
        enabled: Boolean(id),
        retry: false,
        refetchOnWindowFocus: false,
    })

    return {
        movementData: query.data ?? { itemRows: [] },
        isFetching: query.isFetching || query.isLoading,
        error: query.error,
    }
}